import React, {PropTypes} from 'react';
import Consts from '../../../Consts';

class ScreenHeader extends React.Component {
    constructor(props) {
        super(props);
    }

       render() {
        let icon = !this.props.icon.startsWith("http")?Consts.baseDir+"/images/"+this.props.icon:this.props.icon;

        return (
                    <div className="c-Header">
                        <img className={" "+(this.props.iconIsCircle?"pf-AppIcon--circle":"")} src={icon} />
                        <h1 className="c-ProductTitle">{this.props.title}</h1>
                        <h2 className="c-ProductDeveloper">{this.props.text}</h2>
                    </div>                    
            );
        }
}

ScreenHeader.propTypes = {
    title: React.PropTypes.string.isRequired,
    text: React.PropTypes.string.isRequired,
    icon: React.PropTypes.string.isRequired,
    iconIsCircle: React.PropTypes.bool
};


export default ScreenHeader;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Subcomponents/ScreenHeader.js
 **/